import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

import getCheckToken from 'Api/token/getCheckToken';

const useVerifyResetToken = () => {
  const { token } = useParams();

  return useQuery({
    queryKey: ['verify-token', token],
    queryFn: async () => {
      return await getCheckToken({ token });
    },
    enabled: !!token,
    retry: false,
    gcTime: 0,
    refetchOnWindowFocus: false,
  });
};

export default useVerifyResetToken;
